import { UserTypes } from "src/app/enum/user-types";

export class UserData {
    constructor(
        public id: Number,
        public name: string,
        public type?: UserTypes,
        ) { }
}
